import React, { useEffect } from "react";
import { Card, Container, Nav, Tab } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { useDispatch } from "react-redux";
import axios from "axios";

// Components
import Filters from "./components/Filters";

// tab pane
import CeilingVirement from "./components/tab-content/CeilingVirement";
import EditProjectName from "./components/tab-content/EditProjectName";
import EditProjectScopes from "./components/tab-content/EditProjectScopes";
import LocationChanges from "./components/tab-content/LocationChanges";
import ApplyNewProjects from "./components/tab-content/ApplyNewProjects";

// redux
import { getVirementApplications } from "../../../redux/slices/jppn/jppnCeilingVirementSlice";
import { getProjectNameChangesApplications } from "../../../redux/slices/jppn/jppnProjectNameChanges";
import { getProjectScopesChangesApplications } from "../../../redux/slices/jppn/jppnProjectScopesChanges";
import { getLocationChangesApplications } from "../../../redux/slices/jppn/jppnLocationChangesSlice";
import { getNewProjectApplications } from "../../../redux/slices/jppn/jppnApplyNewProjectSlice";

const MainPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    let source = axios.CancelToken.source();

    const initialize = async () => {
      const props = {
        source: source,
      };
      dispatch(getVirementApplications(props));
      dispatch(getProjectNameChangesApplications(props));
      dispatch(getProjectScopesChangesApplications(props));
      dispatch(getLocationChangesApplications(props));
      dispatch(getNewProjectApplications(props));
    };

    initialize();

    return () => {
      source.cancel();
    };
  }, [dispatch]);

  return (
    <React.Fragment>
      <Helmet title='Perakuan JPPN | Senarai Projek' />

      <Container fluid className='p-0'>
        <div className='mb-4'>
          <h4>Senarai permohonan JPPN</h4>
        </div>
        <div className='tab'>
          <Tab.Container defaultActiveKey='apply-new-project'>
            <Nav variant='tabs' fill>
              <Nav.Item>
                <Nav.Link eventKey='apply-new-project'>
                  Penyenaraian Projek Baharu
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey='ceiling-virement'>Kenaikan Siling</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey='edit-project-scopes'>
                  Perubahan Skop
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey='edit-project-name'>Ubah Tajuk</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey='location-changes'>Ubah Lokasi</Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content>
              <ApplyNewProjects eventKey='apply-new-project' />
              <CeilingVirement eventKey='ceiling-virement' />
              <EditProjectScopes eventKey='edit-project-scopes' />
              <EditProjectName eventKey='edit-project-name' />
              <LocationChanges eventKey='location-changes' />
            </Tab.Content>
          </Tab.Container>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default MainPage;
